import { InnerContentItem } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { useTranslation } from "react-i18next";

export function SocialMediaSummaryField({
  field,
}: {
  field: components["schemas"]["SocialMediaCheckField"];
}) {
  const { t } = useTranslation();

  return (
    <>
      {field.value?.facebook_url && (
        <InnerContentItem
          label="Facebook"
          testID="social-media-summary-facebook"
        >
          {field.value.facebook_url}
        </InnerContentItem>
      )}

      {field.value?.instagram_url && (
        <InnerContentItem
          label="Instagram"
          testID="social-media-summary-instagram"
        >
          {field.value.instagram_url}
        </InnerContentItem>
      )}

      {field.value?.linkedin_url && (
        <InnerContentItem
          label="LinkedIn"
          testID="social-media-summary-linkedin"
        >
          {field.value.linkedin_url}
        </InnerContentItem>
      )}

      {field.value?.tiktok_url && (
        <InnerContentItem label="TikTok" testID="social-media-summary-tiktok">
          {field.value.tiktok_url}
        </InnerContentItem>
      )}

      {field.value?.twitter_url && (
        <InnerContentItem label="X" testID="social-media-summary-x">
          {field.value.twitter_url}
        </InnerContentItem>
      )}

      {field.value?.high_school_name && (
        <InnerContentItem
          label={t("High school name")}
          testID="social-media-summary-high-scool"
        >
          {field.value.high_school_name}
        </InnerContentItem>
      )}

      {field.value?.college_name && (
        <InnerContentItem
          label={t("Post secondary institution")}
          testID="social-media-summary-post-secondary-institution"
        >
          {field.value.college_name}
        </InnerContentItem>
      )}
    </>
  );
}
